export const productFooterList = [
  { title: 'Studio', to: '/solutions/studio' },
  { title: 'Defender', to: '/solutions/defender' },
  { title: 'Devkit', to: '/solutions/devkit' },
];

export const companyFooterList = [
  { title: 'Contact Us', to: '/contact-us' },
  { title: 'About', to: '/company' },
  { title: 'Privacy', to: '/privacy-policy' },
  { title: 'Pricing', to: '/pricing' },
  { title: 'Terms and Conditions', to: '/tos' },
];

